import { defaultTheme, SideNavTheme } from '@medly-components/theme';

import colors from './colors';

export const sideNav: SideNavTheme = {
    ...defaultTheme.sideNav,
    bgColor: colors.darkBlue,
    navItem: {
        ...defaultTheme.sideNav.navItem,
        icon: {
            ...defaultTheme.sideNav.navItem.icon,
            color: {
                default: colors.silverGrey[500],
                hovered: colors.silverGrey[500],
                pressed: colors.silverGrey[500],
                active: colors.coral[500]
            }
        },
        text: {
            ...defaultTheme.sideNav.navItem.text,
            color: {
                default: colors.silverGrey[500],
                hovered: colors.silverGrey[500],
                pressed: colors.silverGrey[500],
                active: colors.coral[500]
            }
        },
        bgColor: {
            default: 'transparent',
            hovered: 'transparent',
            pressed: 'transparent',
            active: 'rgba(19, 24, 29, 0.6);'
        }
    }
};
